import React from 'react';
import {Text} from '@chakra-ui/react';
import {components, OptionProps} from 'react-select';

export interface LabelAndDescriptionData<T> {
  label: string;
  description: string;
  value: T;
}

export const LabelAndDescriptionOption = <T,>(
  props: OptionProps<LabelAndDescriptionData<T>, false>
) => {
  const {label, description} = props.data;
  return (
    <components.Option {...props}>
      <Text fontSize="sm">{label}</Text>
      <Text fontSize="xs" mt="1" fontWeight="thin" color="kgray.300">
        {description}
      </Text>
    </components.Option>
  );
};
